module.exports = __webpack_public_path__ + "static/img/6510_phase_function_Paper_PointsHejduk_Prediction.21837c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6510_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7kC+
// module chunks = 0